import {LeagueCompetitor} from "@model";

export class DuplicateCandidate {
    existing?: LeagueCompetitor;
    duplicate?: LeagueCompetitor;
    matchedFields?: MatchedField[];
    notMatchedFields?: MatchedField[];
    resolveStatus?: LeagueCompetitorResolveStatus;
    matchingMembersCount?: number;
    matchedMembers?: MatchedMemberPair[];
}

export class MatchedMemberPair {
    memberFromExisting?: LeagueCompetitor;
    memberFromDuplicate?: LeagueCompetitor;
    matchedFields?: MatchedField[];
    notMatchedFields?: MatchedField[];
}

export enum MatchedField {
    EMAIL,
    FULL_NAME_MATCH,
    FIRST_NAME,
    LAST_NAME,
    FIRST_NAME_SOUNDEX,
    LAST_NAME_SOUNDEX,
    BIRTHDAY,
    DAY_OF_BIRTH,
    MONTH_OF_BIRTH,
    YEAR_OF_BIRTH,
    DAY_MONTH_SWAPPED,
    SEX,
    COUNTRY
}

export enum LeagueCompetitorResolveStatus {
    MERGE = 1,
    KEEP_SEPARATE = 2,
    MARK_DUPLICATE = 3,
}